import api from '../axios-instance';

import type { ApiResponse } from './api.types';
import type { AssignedRiskApplicationAgentViewModel } from '../types/AssignedRiskApplicationAgentViewModel';
import type { AssignedRiskNamesAndAddressesViewModel } from '../types/AssignedRiskNamesAndAddressesViewModel';
import type { AssignedRiskPreviousInsuranceViewModel } from '../types/AssignedRiskPreviousInsuranceViewModel';
import type { AssignedRiskApplicationDetailsViewModel } from '../types/AssignedRiskApplicationDetailsViewModel';
import type { AssignedRiskApplicationPageContextViewModel } from '../types/AssignedRiskApplicationPageContextViewModel';
import type { AssignedRiskApplicationCoverageInformationViewModel } from '../types/AssignedRiskApplicationCoverageInformationViewModel';

function toThrownError(error: unknown): Error {
  return error instanceof Error ? error : new Error('Unexpected non-Error thrown');
}

export const assignedRiskApplicationService = {
  getContext: async (assignedRiskAppId: number): Promise<ApiResponse<AssignedRiskApplicationPageContextViewModel>> => {
    try {
      const response = await api.get(`assigned-risk-applications/${assignedRiskAppId}/context`);
      return { data: response.data, status: response.status };
    } catch (error) {
      throw toThrownError(error);
    }
  },

  getAgentDetails: async (assignedRiskAppId: number): Promise<ApiResponse<AssignedRiskApplicationAgentViewModel>> => {
    try {
      const response = await api.get(`assigned-risk-applications/${assignedRiskAppId}/agent-details`);
      return { data: response.data, status: response.status };
    } catch (error) {
      throw toThrownError(error);
    }
  },

  getApplicationDetails: async (assignedRiskAppId: number): Promise<ApiResponse<AssignedRiskApplicationDetailsViewModel>> => {
    try {
      const response = await api.get(`assigned-risk-applications/${assignedRiskAppId}/application-details`);
      return { data: response.data, status: response.status };
    } catch (error) {
      throw toThrownError(error);
    }
  },

  getInsuranceHistory: async (assignedRiskAppId: number): Promise<ApiResponse<AssignedRiskPreviousInsuranceViewModel[]>> => {
    try {
      const response = await api.get(`assigned-risk-applications/${assignedRiskAppId}/insurance-history`);
      return { data: response.data, status: response.status };
    } catch (error) {
      throw toThrownError(error);
    }
  },

  getNamesAndAddresses: async (assignedRiskAppId: number): Promise<ApiResponse<AssignedRiskNamesAndAddressesViewModel>> => {
    try {
      const response = await api.get(`assigned-risk-applications/${assignedRiskAppId}/names-and-addresses`);
      return { data: response.data, status: response.status };
    } catch (error) {
      throw toThrownError(error);
    }
  },

  getCoverageInformation: async (assignedRiskAppId: number): Promise<ApiResponse<AssignedRiskApplicationCoverageInformationViewModel>> => {
    try {
      const response = await api.get(`assigned-risk-applications/${assignedRiskAppId}/coverage-information`);
      return { data: response.data, status: response.status };
    } catch (error) {
      throw toThrownError(error);
    }
  },
};